import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src875608232/src/niftron-doc/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "niftron-tokenization"
    }}>{`Niftron Tokenization`}</h1>
    <h2 {...{
      "id": "mint-token-createbadge"
    }}>{`Mint Token (CreateBadge)`}</h2>
    <p>{`This is a predefined function to create a tokenized digital badge. This is furthur explored at this `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://tutorials.niftron.com/how-to-create-a-digital-badge"
        }}>{`tutorial`}</a></strong>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { CreateBadgeModel, TokenType } from "niftron-sdk";

...........
const createBadgeModel: CreateBadgeModel = {
  tokenName: "----Unique Name-----",
  tokenType: TokenType.SFT,
  tokenData: "-----Stringified Json From User-----",
  tokenCount: 10,
  previewImageUrl: "---imageURL---",
};

niftron.tokenBuilder
  .CreateBadge(createBadgeModel)
  .then((res) => {
    console.log(res);
  })
  .catch((err) => {
    console.log("err" + err);
  });

`}</code></pre>
    <h2 {...{
      "id": "mint-token-with-custom-options-createbadge"
    }}>{`Mint Token with custom Options (CreateBadge)`}</h2>
    <p>{`This showcases the custom options that each token utilized in forming a token you desire.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { CreateBadgeModel, TokenType, CreateBadgeOptionsModel } from "niftron-sdk";

...........
const createBadgeModel: CreateBadgeModel = {
  tokenName: "----Unique Name-----",
  tokenType: TokenType.SFT,
  tokenData: "-----Stringified Json From User-----",
  tokenCount: 10,
  previewImageUrl: "---imageURL---",
};

const options: CreateBadgeOptionsModel = {
  tradable: true,//default is false
  transferable: true,//default is false
  authorizable: true,//default is false
  encryptData: true,//default is false
};

niftron.tokenBuilder
  .CreateBadge(createBadgeModel,options)
  .then((res) => {
    console.log(res);
  })
  .catch((err) => {
    console.log("err" + err);
  });

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      